import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HelpersService } from 'src/app/core/services/helpers.service';
import {
  GestionarOpsClientesService,
  HistoricoEnvioDetalle,
  HistoricoEnvioRespuesta,
} from '../gestionar-ops-clientes/gestionar-ops-clientes.service';

@Component({
  selector: 'app-modal-historico-envio-detalle',
  templateUrl: './modal-historico-envio-detalle.component.html',
  styleUrls: ['./modal-historico-envio-detalle.component.scss'],
})
export class ModalHistoricoEnvioDetalleComponent implements OnInit {
  cargando = false;
  error = '';
  detalle: HistoricoEnvioDetalle | null = null;
  respuesta: HistoricoEnvioRespuesta | null = null;
  respuestaInvalida = false;

  constructor(
    public dialogRef: MatDialogRef<ModalHistoricoEnvioDetalleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
    private service: GestionarOpsClientesService,
    private helpers: HelpersService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.cargarDetalle();
  }

  async cargarDetalle(): Promise<void> {
    this.cargando = true;
    this.error = '';
    const result = await this.service.getHistoricoEnvioDetalle(this.data.id);
    this.cargando = false;

    if (!result.success || !result.data) {
      this.error = result.message || 'No se pudo cargar el detalle del envío.';
      return;
    }

    this.detalle = result.data;
    this.parsearRespuesta(result.data.RESPONSE_JSON);
  }

  private parsearRespuesta(raw: string): void {
    this.respuesta = null;
    this.respuestaInvalida = false;
    if (!raw) return;
    try {
      this.respuesta = JSON.parse(raw);
    } catch {
      this.respuestaInvalida = true;
    }
  }

  copiarUrl(): void {
    if (!this.detalle?.URL) return;
    navigator.clipboard.writeText(this.detalle.URL);
    this.helpers.notifications.successMessage('URL copiada al portapapeles.');
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
